import { NbiDimensions } from "../../common/generic/generic-nbi-dimensions";
import { IGenericAggregateResponse } from "../../common/generic/generic-types";

export class NbiYtdPerOeCountryOutput {
  public constructor(public data: any[]) {}
}

// tslint:disable-next-line: cognitive-complexity
export function mapData(
  data: IGenericAggregateResponse
): NbiYtdPerOeCountryOutput {
  if (data.aggregates && data.aggregates.length === 0) {
    return new NbiYtdPerOeCountryOutput([]);
  }
  const dimensions = new NbiDimensions();
  const kpiData = [];

  for (const item of data.aggregates ? data.aggregates : []) {
    if (item.dimensionAttributeValues[dimensions.OE_RES_CTRY] != null) {
      item.indicatorKpiValues.nbi_ytd = isNaN(item.indicatorKpiValues.nbi_ytd)
        ? 0
        : item.indicatorKpiValues.nbi_ytd / 1000;
      if (item.indicatorKpiValues.nbi_ytd !== 0) {
        if (item.dimensionAttributeValues[dimensions.OE_RES_CTRY] === "HKG") {
          kpiData.push({ code: "CHN", value: item.indicatorKpiValues.nbi_ytd });
        } else {
          kpiData.push({
            code: item.dimensionAttributeValues[dimensions.OE_RES_CTRY],
            value: item.indicatorKpiValues.nbi_ytd,
          });
        }
      }
    }
  }

  return new NbiYtdPerOeCountryOutput(kpiData);
}
